<span>
  <!-- Role or staff member links to its page; a deleted role is gone, so it is only highlighted -->
  @if (log?.action === 'Delete') {
    <span [innerHTML]="(log?.details?.translationCode | translate : { targetName: log?.details?.targetName | escapeHtml, targetId: log?.details?.targetId | escapeHtml }) | strongWrap : targetString"></span>
  } @else {
    <span [innerHTML]="(log?.details?.translationCode | translate : { targetName: log?.details?.targetName | escapeHtml, targetId: log?.details?.targetId | escapeHtml }) | anchorWrap : log?.details?.targetName : log?.details?.targetId : 'AccessRole'"></span>
  }
  {{ " " + ("WAS_MODIFIED_BY" | translate) + " " }}
  @if (!log?.staffId && log?.staffName === 'Everon Admin') {
    <strong>Everon Admin</strong>
  } @else {
    <a [routerLink]="['/staff', log?.staffId]" (click)="closeDialog.emit()">
      {{ log?.staffName | identityFormat : log?.staffId }}
    </a>
  }
</span>

<p class="mt-1">{{ log?.timestamp | moment : "l LTS" }}</p>

<hr />

<div class="container">
  @if (nameChanged) {
    <span class="item-title">{{ (log?.details?.translationCode === 'STAFF_ACCESS_ROLE_ASSIGNED' ? 'ROLE' : 'NAME') | translate }}:</span>
    <div class="item-pair-value" data-testid="access-role-name-change">
      <span class="negative-highlight line-through">{{ changes.oldName ? (roleNameKey(changes.oldName) | translate) : ('NONE' | translate) }}</span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">{{ changes.newName ? (roleNameKey(changes.newName) | translate) : ('NONE' | translate) }}</span>
    </div>
  }

  @for (change of grantChanges; track change.area) {
    <span class="item-title">{{ change.nameKey | translate }}:</span>
    <div class="item-pair-value" [attr.data-testid]="'access-role-grant-' + change.area">
      <span class="negative-highlight line-through">{{ levelKey(change.oldValue) | translate }}</span>
      <i class="fa-light fa-arrow-right-long fa-lg"></i>
      <span class="positive-highlight">{{ levelKey(change.newValue) | translate }}</span>
    </div>
  }

  @if (!nameChanged && grantChanges.length === 0) {
    <span class="text-muted">{{ 'ACTIVITY_NO_CHANGES' | translate }}</span>
  }
</div>
